import { render, staticRenderFns } from "./store_in.vue?vue&type=template&id=a28eb80a"
import script from "./store_in.vue?vue&type=script&lang=js"
export * from "./store_in.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports